// Cursor picking a row out of a list -- the "Prefilled" filter toggle, which
// preselects an option for the agent instead of leaving the filter empty.
// Source SVG carried no fill on its shapes (they inherited the black default);
// fill="currentColor" on the root is what lets a caller color it, e.g.
// ToggleRow's green badge.
export const PrefilledIcon = (props) => {
  return (
    <svg fill="currentColor" height={16} viewBox="0 0 478.138 478.138" width={16} {...props}>
      <polygon points="0,208.676 0,269.527 254.535,269.527 240.946,208.676" />
      <path d="M0,373.002v60.873h409.823v-56.947c-3.991-0.82-7.809-2.243-11.562-3.969L0,373.002L0,373.002z" />
      <polygon points="242.758,55.264 328.372,105.158 409.823,105.158 409.823,44.263 0,44.263 0,105.158 217.822,105.158 211.804,78.129" />
      <path d="M244.268,84.406l-5.242,3.947l58.953,264.005l47.564-80.437l50.476,69.005c9.599,13.029,26.554,16.782,38.029,8.391c11.389-8.369,13.007-25.648,3.451-38.676l-50.497-69.005l91.137-21.075L244.268,84.406z" />
    </svg>
  );
};
